import axiosInstance from "../../../api/axiosConfig";
import type {
  ConnectResponse,
  ConnectorStatusResponse,
  ConnectorsResponse,
  DisconnectResponse
} from "../types";

// `axiosInstance.baseURL` already ends in `/api`.
const BASE = "/connectors";

export const ConnectorsAPI = {
  async list(): Promise<ConnectorsResponse> {
    const { data } = await axiosInstance.get<ConnectorsResponse>(BASE);
    return { enabled: Boolean(data.enabled), items: data.items ?? [] };
  },
  /** One app's state, catalog or not (the connect card polls this). */
  async status(slug: string): Promise<ConnectorStatusResponse> {
    const { data } = await axiosInstance.get<ConnectorStatusResponse>(
      `${BASE}/${encodeURIComponent(slug)}`
    );
    return data;
  },
  /** Starts authorization; the caller opens `redirect_url` (a Composio Connect Link). */
  async connect(slug: string, callbackUrl: string): Promise<ConnectResponse> {
    const { data } = await axiosInstance.post<ConnectResponse>(
      `${BASE}/${encodeURIComponent(slug)}/connect`,
      { callback_url: callbackUrl }
    );
    return data;
  },
  async disconnect(slug: string): Promise<DisconnectResponse> {
    const { data } = await axiosInstance.delete<DisconnectResponse>(
      `${BASE}/${encodeURIComponent(slug)}`
    );
    return data;
  }
};
